import { render } from "./designAddress.vue?vue&type=template&id=c619dbee"
import script from "./designAddress.vue?vue&type=script&lang=js"
export * from "./designAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__